import {
  GET_ACTIVE_DIVERSIONS_REQUEST,
  GET_ACTIVE_DIVERSIONS_SUCCESS,
  GET_ACTIVE_DIVERSIONS_FAILURE,
} from '../constants/ActionTypes';

/**
 * Active-diversion list slice.
 *
 *   loading      — true while a getActiveDiversions() fetch is in flight.
 *   list         — DiversionStatusResponse[] (12 fields each; see
 *                  src/api/Diversion.js JSDoc).
 *   lastFetched  — epoch ms of the last successful fetch (informational;
 *                  task 10 may use this for a "refreshed N seconds ago"
 *                  affordance, but it's not required).
 *   error        — last failure's normalised error object, or null.
 *
 * The slice is plain-object (matches every other reducer in this codebase
 * — no ImmutableJS, see src/reducers/drivers.js, src/reducers/eca.js).
 *
 * Refetch policy: REQUEST preserves the existing list + lastFetched so
 * the DiversionsOverview tab doesn't flicker empty during a re-list
 * triggered by the WSNotifications dual-dispatch (task 04). FAILURE
 * also preserves the list so the last successful snapshot stays visible
 * while an inline error surfaces.
 */
export const initialState = {
  loading: false,
  list: [],
  lastFetched: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTIVE_DIVERSIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ACTIVE_DIVERSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.list,
        lastFetched: Date.now(),
        error: null,
      };
    case GET_ACTIVE_DIVERSIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
